<template>
    <div>
        <div class="card shadow">
            <div class="card-header bg-transparent">
                <div>
                    <a @click="$router.go(-1)"><i class="fa fa-arrow-left" aria-hidden="true"></i></a> 
                    <h3 class="mb-2">
                        <!-- {{ $t('message.add') }} {{ $tc('message.patients', 1) }} -->
                        Liste des patients sans intervention 
                    </h3>
                </div>
                <div class="col">
                    <div class="form-group">
                        <label for="type">Filtrer le graphe en fonction du nombre de jour</label>
                        <select name="type" id="type" v-model="type" @change="getPatientofListSansIntervention" class="form-control">
                            <option value="7">7</option>
                            <option value="14">14</option>
                            <option value="30">30</option>
                            <option value="90">90</option>
                            <option value="2000">2000</option>
                        </select>
                    </div>
                    
                </div>
                <div class="mt-5">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th scope="col">#</th>
                          <th scope="col">Nom</th>
                          <th scope="col">Prénom</th>
                          <th scope="col">Téléphone</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="(item,index) in sortedCats" :key="item.id">
                        <!-- <tr v-for="item in sortedCats" :key="item.id"> -->
                          <th scope="row"> {{index+1}} </th>
                          <td>{{item.nom}}</td>
                          <td>{{item.prenom}}</td>
                          <!-- <td>{{item.numero_dossier}}</td> -->
                          <td>{{item.telephone}}</td>
                        </tr>
                      </tbody>
                    </table>

                    <p>
                       page {{currentPage}}
                    </p>
                    <button @click="prevPage">Previous</button> 
                    <button @click="nextPage">Next</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { required, email, minLength,integer,maxLength } from 'vuelidate/lib/validators';
    import _ from 'lodash';
    import SlimSelect from 'slim-select';
    import Multiselect from 'vue-multiselect'
    import moment from "moment";
    import Swal from 'sweetalert2';
    import AppConfig from '../../constants/AppConfig';
    import axios from "axios";

    export default {
        name: "AddPatient",
        components:{
            Multiselect
        },

        computed: {
            ...mapGetters(["countries", "subsc  ribers", "errors",'hasAdminRole',
                'hasGestionnaireRole','hasPraticienRole','hasMedecinControleRole','hasAssistante',
                'hasSouscripteurRole',
                'hasAssistante','controlDoctors'
            ]),

            can:function(){
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasPraticienRole || this.hasMedecinControleRole || this.hasSouscripteurRole || this.hasAssistante;
            },

            mPatients: function() {
                let cArray = [];
                // console.log(this.rdvs);
                _.forEach(this.patients, function(patient) {
                    let c = {};
                    let user = patient.user;
                      if(user != null){
                        // if(user.dossier != null){
                          c.prenom =  user.prenom != null ? user.prenom : '';
                          c.nom = (user.nom).toUpperCase();
                          c.id = user.id ;
                          c.telephone = patient.user.telephone ;
                          cArray.push(c);
                        // }
                      }
                    
                });
                this.cats = cArray;
                return cArray;
            },
            sortedCats:function() {
              return this.mPatients.sort((a,b) => {
                let modifier = 1;
                if(this.currentSortDir === 'desc') modifier = -1;
                if(a[this.currentSort] < b[this.currentSort]) return -1 * modifier;
                if(a[this.currentSort] > b[this.currentSort]) return 1 * modifier;
                return 0;
              }).filter((row, index) => {
                let start = (this.currentPage-1)*this.pageSize;
                let end = this.currentPage*this.pageSize;
                if(index >= start && index < end) return true;
              });
            },
        },

        data() {
            return {
              patients: [],
              type: 7,
              currentSort:'name',
              currentSortDir:'asc',
              pageSize:10,
              currentPage:1,
            }
        },
        watch:{

        },

        methods: {
          sort:function(s) {
            //if s == current sort, reverse
            if(s === this.currentSort) {
              this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';
            }
            this.currentSort = s;
          },
          nextPage:function() {
            if((this.currentPage*this.pageSize) < this.mPatients.length) this.currentPage++;
          },
          prevPage:function() {
            if(this.currentPage > 1) this.currentPage--;
          },
            getPatientofListSansIntervention() {
              let date= this.type;
              axios.get(`${AppConfig.apiUrl}/patient-sans-intervention/${date}`, {headers: { Authorization: `Bearer ${localStorage.getItem('ms-token')}` }})
              .then(res=>{   
                // console.log(res.data.patients);
                  this.patients = res.data.patients;
              })
              // this.sortedCats();
            },

            onSubmit: function(evt) {
                evt.preventDefault();

                this.$v.$touch();
                this.is_loading = true;
            },

            onReset: function(evt) {
                evt.preventDefault();

                // Reset our form values
                this.form.ancien_medecin_referent = '';
                this.form.nouveau_medecin_referent = '';
                this.form.patients = '';
                // Trick to reset/clear native browser form validation state
                this.show = false;

                this.$nextTick(() => {
                    this.show = true;
                });
            },

            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            }
        },

        validations() {
            return {
                form: {
                }
            }
        },
        created() {
        
        },
        mounted() {
          this.getPatientofListSansIntervention();
          // this.getPatients();
        }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
    @import url('~slim-select/dist/slimselect.min.css');
</style>